// extracted by mini-css-extract-plugin
export default {"container":"dxwShE","inner":"RJIWvU","slide":"LDceGG","prevActive":"LB8kBf","active":"ILhCil"};